import React from "react";
import "./ContactUs.css";

/* ================= SVG ICONS ================= */
const MapPinIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
    <circle cx="12" cy="10" r="3" />
  </svg>
);

const PhoneIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6.19-6.19 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.6 3h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 10.6a16 16 0 0 0 6.01 6.01l.97-.97a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" />
  </svg>
);

const MailIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="4" width="20" height="16" rx="2" />
    <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
  </svg>
);

const GlobeIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10" />
    <line x1="2" y1="12" x2="22" y2="12" />
    <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
  </svg>
);

const ShieldCheckIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
    <path d="m9 12 2 2 4-4" />
  </svg>
);

/* ================= COMPONENT ================= */
function ContactUs() {
  const certifications = [
    {
      title: "Registered Trust (Pondicherry Govt)",
      pdf: "/pdfs/registered-trust-certificate.pdf",
    },
    {
      title: "80G Form 10AB Filed",
      pdf: "/pdfs/Form 10AB_Filed Form-1.pdf", 
    },
    {
      title: "DARPAN Registered ",
      pdf: "/pdfs/Durpan.pdf",
    },
    {
      title: "PAN Registered",
      pdf: "/pdfs/Tan-certificate.pdf",
    },
    {
      title: "License",
      pdf: "/pdfs/License.pdf",
    }

  ];

  return (
    <div className="contact-page-wrapper">
      
      {/* ================= HERO BANNER ================= */}
      <section className="contact-hero" style={{
        backgroundImage: "url('/images/bread.jpg')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}>
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <h1 className="hero-title" style={{ textAlign: "center" }}>Contact Us</h1>
          <div className="hero-breadcrumb">
            <span className="breadcrumb-link">Home</span>
            <span className="breadcrumb-arrow">➔</span>
            <span className="breadcrumb-current">Contact Us</span>
          </div>
        </div>
      </section>

      {/* ================= MAIN CONTENT SECTION ================= */}
      <section className="contact-main-section">
        <div className="contact-container">
          
          {/* Section Introduction */}
          <div className="section-header center">
            <span className="badge-contact">COMMUNICATION DESK</span>
            <h2 className="main-heading">Get in Touch With Us</h2>
            <p className="intro-desc">
              We would love to hear from you. Reach out to our central administration for general support inquiries, strategic partnerships, or corporate contribution documentation.
            </p>
          </div>

          {/* Dual Layout Grid: Info Cards & Interactive Map */}
          <div className="contact-grid">
            
            {/* Contact Details Directory */}
            <div className="contact-info-card">
              
              <div className="info-item">
                <span className="info-icon"><MapPinIcon /></span>
                <div className="info-content">
                  <h3>Our Headquarters Address</h3>
                  <p>No. 14/60, 8th Cross, Brindhavanam,<br />Puducherry – 605013</p>
                  
                   <h3>Our Branch Address</h3>
                  <p>No.12, 1st Cross, Annai Theresa Nagar, Moolakulam,<br /> Puducherry - 605 010</p>
                </div>
              </div>

              <div className="info-item">
                <span className="info-icon"><PhoneIcon /></span>
                <div className="info-content">
                  <h3>Direct Call Lines</h3>
                  <p>
                    <a href="tel:+919445724840">+91 94457 24840</a>
                    {" / "}
                    <a href="tel:+918668106574">+91 86681 06574</a>
                  </p>
                </div>
              </div>

              <div className="info-item">
                <span className="info-icon"><MailIcon /></span>
                <div className="info-content">
                  <h3>Official Electronic Mail</h3>
                  <p>
                    <a href="mailto:support@anukcharitabletrust.com">support@anukcharitabletrust.com</a>
                  </p>
                </div>
              </div>

              <div className="info-item">
                <span className="info-icon"><GlobeIcon /></span>
                <div className="info-content">
                  <h3>Central Domain Website</h3>
                  <p>
                    <a href="https://www.anukcharitabletrust.com/" target="_blank" rel="noopener noreferrer">
                      www.anukcharitabletrust.com
                    </a>
                  </p>
                </div>
              </div>

            </div>

            {/* Embedded Geographical Map Card */}
            <div className="contact-map-card">
              <div className="map-wrapper">
                <iframe
                  title="Anuk Charity Operational Headquarters Location"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3902.1567890123!2d79.8123456789!3d11.9345678901!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a5361a1b2c3d4e5%3A0x1234567890abcdef!2sPuducherry!5e0!3m2!1sen!2sin!4v1700000000000!5m2!1sen!2sin"
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>
            </div>

          </div>

          {/* ================= CERTIFICATIONS SECTION ================= */}
          <div className="certifications-section">
            <h2 className="cert-title">Trust &amp; Certifications</h2>
            <p className="cert-subtitle">
              We operate under verified official statutory registrations:
            </p>

            <div className="cert-grid-single-line">
              {certifications.map((cert, index) => (
                <a
                  key={index}
                  href={cert.pdf}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="cert-card cert-link"
                >
                  <span className="cert-icon">
                    <ShieldCheckIcon />
                  </span>
                  <span className="cert-text">{cert.title}</span>
                </a>
              ))}
            </div>
          </div>

        </div>
      </section>

    </div>
  );
}

export default ContactUs;